import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(_setup.ListItemFilters, {
        attrs: {
          icon: "ui-icon-disease",
          title:
            _setup.doctorFiltersState.disease?.name ||
            _setup.t("Что лечит врач", _setup.options),
          subtitle: _setup.doctorFiltersState.disease
            ? _setup.t("Заболевание", _setup.options)
            : "",
        },
        on: { click: _setup.openDialog },
      }),
      _vm._v(" "),
      _c(_setup.DiseaseModal, {
        attrs: {
          value: _setup.isDialogOpened,
          "is-back": "",
          title: _setup.t("Что лечит врач", _setup.options),
          placeholder: _setup.t("Заболевание", _setup.options),
          "page-type": _setup.pageType,
          "town-id":
            _setup.doctorFiltersState.visitLocation === "online"
              ? undefined
              : _setup.commonStore.town.id,
          "speciality-id": _setup.doctorFiltersState.speciality.id,
          "selected-disease": _setup.filtersStore.unsavedFilters.disease,
        },
        on: {
          "disease:selected": _setup.onClickDisease,
          "disease:reset": _setup.onResetDisease,
          input: _setup.handleCloseDiseaseModal,
        },
        scopedSlots: _vm._u([
          {
            key: "footer",
            fn: function ({ selectedDisease }) {
              return [
                _c(
                  "div",
                  { staticClass: "pa-2 elevation-8" },
                  [
                    _c(
                      VBtn,
                      {
                        attrs: {
                          block: "",
                          depressed: "",
                          color: "primary",
                          disabled: !_setup.hasUnsavedDisease,
                        },
                        on: {
                          click: function ($event) {
                            return _setup.handleDiseaseSelected(selectedDisease)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_setup.t("Применить", _setup.options)) +
                            "\n        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }